import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { initialState as staticLoadState } from "./StaticLoadState";
import { IState } from "slices";

export const staticLoadSlice = createSlice({
    name: "staticLoad",
    initialState: staticLoadState,
    reducers: {
        setStaticLoad: (state, action: PayloadAction<{ division: string, weekStartDate: string }>) => {
            state.selectedDivision = action.payload.division;
            state.weekStartDate = action.payload.weekStartDate;
        },
        setPlanId: (state, action: PayloadAction<string>) => {
            state.selectedPlanId = action.payload;
        },
        setSourceDay: (state, action: PayloadAction<string>) => {
            state.sourceDay = action.payload;
        },
        setTurnNumber: (state, action: PayloadAction<string>) => {
            state.turnNumber = action.payload;
        },
        setSelectedWeekStartDate: (state, action: PayloadAction<string>) => {
            state.weekStartDate = action.payload;
        },
        setSelectedScheduleType: (state, action: PayloadAction<string>) => {
            state.selectedScheduleType = action.payload;
        }
    },
});

export const {
    setStaticLoad,
    setPlanId,
    setSourceDay,
    setTurnNumber,
    setSelectedWeekStartDate,
    setSelectedScheduleType
} = staticLoadSlice.actions;

export const staticLoadSelector = (state: IState) => state.staticLoad;

const staticLoadReducer = staticLoadSlice.reducer;
export default staticLoadReducer;
